/* eslint-disable react/prop-types */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -7)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 7)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "white"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "2.479e-4 0.25385 26.935 0.25385 26.935 24.999 2.479e-4 24.999"
})), /*#__PURE__*/React.createElement("path", {
  d: "m20.057 13.557l-8.8936 4.9923c-1.7637 0.90673-1.7772-0.79808-1.7772-0.79808l0.085821-10.226c0.068464-1.7981 1.6991-0.8625 1.6991-0.8625l8.8145 5.326c1.0106 0.74712 0.071357 1.5683 0.071357 1.5683zm6.8785-6.7625c0.029659-3.5163-2.8053-6.3923-6.3327-6.4221l-14.062-0.11849c-3.5264-0.028627-6.4096 2.7973-6.4395 6.3146l-0.10052 11.891c-0.029659 3.5173 2.8053 6.3923 6.3327 6.4212l14.061 0.11827c3.5274 0.030769 6.4106-2.7971 6.4395-6.3135l0.10148-11.891z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "white"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0.48229 0.23068 12 0.23068 12 20.483 0.48229 20.483"
})), /*#__PURE__*/React.createElement("path", {
  d: "m0.48229 15.578l8.1502 4.446c3.1058 1.53 3.2138-1.255 3.2138-1.255l0.15382-16.71c-0.032727-2.936-3.0229-1.454-3.0229-1.454l-8.3913 4.57-0.10364 10.403z",
  fill: "currentColor"
}))))), 'CategoryFM', {
  viewBox: '0 0 40 25'
});